<template>
  <Card :title="$t('conclusion.title')" :footer-divider="false">
    <template #content>
      <strong>{{ $t('conclusion.sections.conclusion.heading') }}</strong>
      <p
        v-dompurify-html="$t('conclusion.sections.conclusion.text', { conclusionNumber })"
      ></p>
      <strong>{{ $t('conclusion.sections.questions.heading') }}</strong>
      <p
        style="margin-bottom: calc(var(--baseline) * 2)"
        v-dompurify-html="$t('conclusion.sections.questions.text')"
      ></p>

      <hr class="line-break" />

      <Collapser
        class="collapser-spacing"
        :collapserTitle="$t('conclusion.sections.evb.heading')"
      >
        <template v-slot:collapserContent>
          <span
            class="collapser-spacing"
            v-dompurify-html="$t('conclusion.sections.evb.text')"
          ></span>
        </template>
      </Collapser>

      <hr class="line-break" />

      <Collapser
        class="collapser-spacing"
        :collapserTitle="$t('conclusion.sections.overview.heading')"
      >
        <template v-slot:collapserContent>
          <span
            class="collapser-spacing"
            v-dompurify-html="$t('conclusion.sections.overview.text')"
          ></span>
        </template>
      </Collapser>

      <hr class="line-break" />

      <Collapser
        class="collapser-spacing"
        :collapserTitle="$t('conclusion.sections.premium.heading')"
      >
        <template v-slot:collapserContent>
          <span
            class="collapser-spacing"
            v-dompurify-html="$t('conclusion.sections.premium.text')"
          ></span>
        </template>
      </Collapser>

      <hr class="line-break" />

      <Collapser
        class="collapser-spacing"
        :collapserTitle="$t('conclusion.sections.currentContract.heading')"
      >
        <template v-slot:collapserContent>
          <span
            class="collapser-spacing"
            v-dompurify-html="$t('conclusion.sections.currentContract.text')"
          ></span>
        </template>
      </Collapser>

      <hr class="line-break" />

      <Collapser
        class="collapser-spacing"
        :collapserTitle="$t('conclusion.sections.overlapPeriods.heading')"
      >
        <template v-slot:collapserContent>
          <span
            class="collapser-spacing"
            v-dompurify-html="$t('conclusion.sections.overlapPeriods.text')"
          ></span>
        </template>
      </Collapser>

      <hr class="line-break" />

      <Collapser
        class="collapser-spacing"
        :collapserTitle="$t('conclusion.sections.ivk.heading')"
      >
        <template v-slot:collapserContent>
          <span
            class="collapser-spacing"
            v-dompurify-html="$t('conclusion.sections.ivk.text')"
          ></span>
        </template>
      </Collapser>

      <hr class="line-break" />

      <Collapser
        class="collapser-spacing"
        :collapserTitle="$t('conclusion.sections.digital.heading')"
      >
        <template v-slot:collapserContent>
          <span
            class="collapser-spacing"
            v-dompurify-html="$t('conclusion.sections.digital.text')"
          ></span>
        </template>
      </Collapser>

      <hr class="line-break" />

      <strong>{{ $t('conclusion.sections.support.heading') }}</strong>
      <span v-dompurify-html="$t('conclusion.sections.support.text')"></span>
    </template>
    <template #footer>
      <div class="footer-cta footer-cta--left">
        <div class="card-row__col">
          <CustomButton
            @click="navigateToContractOverview"
            :buttonColor="ButtonColor.SECONDARY"
          >
            {{ $t('conclusion.buttonText') }}
          </CustomButton>
        </div>
      </div>
    </template>
  </Card>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { ButtonColor, Card, Collapser, CustomButton } from 'de-zurich-ui-library'
import { getIdLevel } from '@/utils/KeycloakUtils'
import { navigate } from '@/utils/NavigationUtils'

defineProps({
  conclusionNumber: {
    type: String,
    required: true
  },
  evbNumber: {
    type: String,
    default: ''
  }
})

const isIdLevel0 = ref(false)

onMounted(() => {
  const idLevelClaim = getIdLevel()
  isIdLevel0.value = idLevelClaim != null && idLevelClaim === 0
})

function navigateToContractOverview(): void {
  navigate(globalThis.ENV_CONFIG?.REDIRECTS.CONTRACT_LIST_PAGE)
}
</script>

<style scoped>
.collapser-spacing {
  margin-bottom: calc(var(--baseline) * 2);
}
.line-break {
  margin-bottom: calc(var(--baseline) * 2);
  height: 1px;
  border: 1px solid #bfcdd8;
}
</style>
